import { DataQueryField } from './data-query-field.model';
import * as _ from 'lodash';
import { moveItemInArray } from '@angular/cdk/drag-drop';

export class DataQueryResult {

    // Server Properties
    Columns: DataQueryField[] = [];
    Data: any[][] = [];
    Errors: string;
    QueryString: string;
    RecordCounts: number;

    // Local Properties
    get ColumnHeaders(): string[] {
        const header: string[] = [];
        for (let i = 0; i < this.Columns.length; i++) {
            const alias = this.Columns[i].Alias != '' ? this.Columns[i].Alias : ('blankheader' + i);
            header.push(alias);
        }
        return header;
    }

    // Methods
    assertOrder(otherResults: DataQueryResult) {
        // PRE: another set of results with the same columns
        // POST: asserts this results order on that result set
        const columnOrder: number[] = [];
        otherResults.Columns.forEach(column => {
            const index = this.Columns.findIndex(o => _.isEqual(column, o));
            columnOrder.push(index);
        });
        const newColumns: DataQueryField[] = [];
        for (let i = 0; i < otherResults.Columns.length; i++) {
            newColumns[columnOrder[i]] = otherResults.Columns[i];
        }
        otherResults.Columns = newColumns;
        const newData: any[][] = [];
        otherResults.Data.forEach(dataRow => {
            const newDataRow: any[] = [];
            for (let j = 0; j < dataRow.length; j++) {
                newDataRow[columnOrder[j]] = dataRow[j];
            }
            newData.push(newDataRow);
        });
        otherResults.Data = newData;
    }

    reorder(indexA, indexB) {
        // PRE: moves the item from index A to index B, pushing "out" all the others
        // POST: switches the indexes on all results

        // Gathering excluded columns
        const excludedColumnAliases = ['lngStudentId', 'MassTools'];
        excludedColumnAliases.forEach(columnAlias => {
            const index = this.Columns.findIndex(column => column.Alias == columnAlias);
            if (index >= 0) {
                if (indexA >= index) {
                    indexA += 1;
                }
                if (indexB >= index) {
                    indexB += 1;
                }
            }
        });

        // Column Swap
        moveItemInArray(this.Columns, indexA, indexB);

        // Data Swap
        for (let i = 0; i < this.Data.length; i++) {
            moveItemInArray(this.Data[i], indexA, indexB);
        }
    }
}
